import { createContext } from 'react';

export type DevModalContextType = {
  isDevModalOpen: boolean;
  openDevModal: () => void;
  closeDevModal: () => void;
  shouldShowDevButton: boolean;
  // Dev flag override management
  devFlagOverrideKey: number;
  registerDevFlagListener: (callback: () => void) => () => void;
};

/**
 * Separate from DevModalProvider, and must stay dependency-free beyond React.
 *
 * launchDarklyInterceptor reads registerDevFlagListener off this context, so anything this module
 * imports lands in the feature-flag path on every page. DevModalProvider's `dynamic()` import also
 * makes that whole chain an async module under Turbopack, which the synchronous flags hook cannot
 * resolve (`useFlags is not a function` during prerender).
 */
export const DevModalContext = createContext<DevModalContextType | null>(null);
